import React, { FC } from 'react'

const SplitLine: FC<{ id: string }> = ({ id }) => (
  <div
    id={id}
    style={{
      borderBottom: '1px solid var(--neutral-400)',
      width: '100%',
      maxWidth: '1200px',
      marginTop: '10px',
      marginBottom: '40px',
    }}
  />
)
export default SplitLine

